import Vue from 'vue'
import Router from 'vue-router'
import routes from '@/router/router'
import store from '@/store'

Vue.use(Router)

const createRouter = () => new Router({
  mode: 'history', // 20260206修改 原版本为注释的
  routes: routes
})

const router = createRouter()
// eslint-disable-next-line
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
  console.log(111)
}

router.beforeEach((to, from, next) => {
  console.log(to.path, from.path, 'to, from, next')
  // 上一页路由
  store.state.user.fromPath = from.path
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js